

import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IBTooltip extends Vue {

	@Prop(Boolean)
	readonly light!: boolean

	@Prop([ String, Number ])
	readonly width!: string | number

	@Prop({ type: String, default: 'top' })
	readonly position!: string

	get widthString(): string {
		return typeof this.width === 'number'
			? `${this.width}px`
			: this.width;
	}

}

